/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { AMENITIES } from '../../../../../../modules/amenities';
import CurrentPageContext from '../../../../../contexts/CurrentPageContext';
import AmenityIcon from '../../../../stateless/AmenityIcon';
import styles from './Amenities.scss';

export default class Amenities extends React.Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    amenities: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      token: PropTypes.string,
    })).isRequired,
    maxItems: PropTypes.number,
    renderAmenityIcons: PropTypes.bool,
    isModal: PropTypes.bool,
  };


  static defaultProps = {
    maxItems: 6,
    renderAmenityIcons: undefined,
    isModal: undefined,
  };

  static contextType = CurrentPageContext;

  state = {
    expanded: false,
  };

  toggleAmenities = () => {
    const { expanded: currentExpanded } = this.state;
    this.setState({ expanded: !currentExpanded });
  }

  getAmenityNames = () => {
    const { amenities } = this.props;
    if (!amenities) {
      return [];
    }
    const amenityNames = amenities.map(amenity => amenity.name);
    return amenityNames;
  }

  gatherAmenityIcons = () => {
    const { amenities } = this.props;
    if (!amenities || !amenities.length) {
      return [];
    }
    const amenityNames = this.getAmenityNames();
    const allTheGoodies = [];
    amenityNames.forEach((amenityName) => {
      const amenity = AMENITIES
        .find(({ test }) => test(amenityName)); // eslint-disable-line jest/no-disabled-tests
      if (amenity) {
        allTheGoodies.push(amenity.id);
      }
    });
    return allTheGoodies;
  }

  renderAmenityIcons() {
    const allAmenityIcons = this.gatherAmenityIcons();
    const { isModal, renderAmenityIcons } = this.props;
    const { expanded } = this.state;
    if (!expanded && renderAmenityIcons && !isModal) {
      return (
        <div className={styles.icons}>
          {allAmenityIcons.map(id => <AmenityIcon key={id} id={id} />)}
        </div>
      );
    }
    return null;
  }

  render() {
    const { secondaryColorClass } = this.context;
    const { type, maxItems } = this.props;
    const { expanded } = this.state;
    const amenityNames = this.getAmenityNames();
    const features = [
      type,
      ...amenityNames,
    ];
    const hasExtras = features.length > maxItems;
    const hideExtras = hasExtras && !expanded;
    const featuresToShow = hideExtras ? features.slice(0, maxItems) : features;

    return (
      <div className={styles.amenities}>
        <div className={styles.amenityIcons}>
          {this.renderAmenityIcons()}
        </div>
        <div>
          {featuresToShow.join(', ')}
        </div>
        {hasExtras
          && (
          <div
            onClick={this.toggleAmenities}
            className={`${styles.contentToggle} ${secondaryColorClass}`}
          >
            View {expanded ? 'Less' : 'More'}
          </div>
          )
        }
      </div>
    );
  }
}
